import { UpdateDatasetRequest, updateDataset } from '@/data/mutations';
import { useOrganizationId } from '@/hooks/useSwr';
import { DatasetSchema, DatasetTransformationSchema } from '@/types/schema';

import { schemaChanged } from '../utils';
import { useDatasetDetails } from './useDatasetDetails';
import { useDatasetSchemaStore } from './useSchemaStore';

export const useUpdateDataset = (dataset?: DatasetSchema) => {
  const organizationId = useOrganizationId();

  const name = useDatasetDetails((state) => state.name);
  const description = useDatasetDetails((state) => state.description);
  const inputSchema = useDatasetSchemaStore((state) => state.inputSchema);
  const outputSchema = useDatasetSchemaStore((state) => state.outputSchema);
  const transformations = useDatasetSchemaStore(
    (state) => state.transformations
  );

  return {
    update: (updatedExamplesOverride, updatedExamples) => {
      if (organizationId && dataset) {
        return updateDataset(organizationId, {
          id: dataset.id,
          name,
          description,
          data_type: 'kv',
          ...getUpdatedFields(
            dataset,
            inputSchema,
            outputSchema,
            transformations
          ),
          patch_examples: updatedExamplesOverride ?? updatedExamples,
        });
      } else {
        return Promise.reject(new Error('No organization ID'));
      }
    },
  };
};

function getUpdatedFields(
  dataset: DatasetSchema,
  inputSchema: Record<string, unknown> | null,
  outputSchema: Record<string, unknown> | null,
  transformations: DatasetTransformationSchema[] | undefined
) {
  const updates = {} as Partial<UpdateDatasetRequest>;

  if (schemaChanged(inputSchema, dataset?.inputs_schema_definition)) {
    updates.inputs_schema_definition = inputSchema;
  }

  if (schemaChanged(outputSchema, dataset?.outputs_schema_definition)) {
    updates.outputs_schema_definition = outputSchema;
  }

  if (schemaChanged(transformations, dataset?.transformations)) {
    updates.transformations = transformations;
  }

  return updates;
}
